import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "react-circular-progressbar/dist/styles.css";
import styled from "styled-components";
import useDisplay from "../../hooks/useDisplay";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH2HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import { route } from "../../router/route";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import Pagination from "./../../components/molecules/pagination";
import { paymentSubTabList, tabList } from "./../../constant/myPageTab";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import PrimaryBtn from "./../../components/atoms/button/primaryBtn";
import LectureSwiper from "./../../components/templates/home/lectureSwiper";
import MainBorderBtn from "./../../components/atoms/button/mainBorderBtn";
import ConfirmModal from "../../components/templates/modals/confirmModal";
import LSRgBody02 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody02";
import MOContainer from "../../components/atoms/layout/moContainer";
import SelectBox from "../../components/organisms/SelectBox";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import LectureItem from "../../components/organisms/lecture/lectureItem";
import LSRgCaption01 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption01";
import PaymentApi from "../../api/payment.api";
import { errorHandler } from "../../util/errorHandler";
import Empty from "../../components/molecules/empty";
import MemberApi from "../../api/member.api";
import LectureApi from "../../api/lecture.api";
import { toast } from "react-toastify";
import moment from "moment";
import { formatNumberWithCommas } from "../../util/formatNumber";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import StyledSubCategoryItem from "../../components/molecules/button/styledSubCategoryItem";

const MyPagePayment = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [membershipInfo, setMembershipInfo] = useState({});
  const [dataList, setDataList] = useState([]);

  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page"));
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(tabList[4].title);

  const [selectedSubMenuTabOpen, setSelectedSubMenuTabOpen] = useState(false);
  const [selectedSubMenuTab, setSelectedSubMenuTab] = useState(
    paymentSubTabList[0].title,
  );

  // 구독 여부
  const [isSubscribed, setIsSubscribed] = useState(false);

  // 선택된 탭
  const typeList = ["구독", "구독 내역", "해지 내역"];
  const [selectedType, setSelectedType] = useState(typeList[0]);

  // ---------- 모달 관련 ---------- //
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCanceling, setIsCanceling] = useState(false);
  const [mostPremiumList, setMostPremiumList] = useState([]);

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(route.my_page_payment)}`,
        { replace: true },
      );
      return;
    }

    const membership = sessionStorage.getItem("membership");

    if (membership === "true") {
      setIsSubscribed(true);
    } else {
      setIsSubscribed(false);
    }

    lectureListFunc();
    getMyMembershipInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const lectureListFunc = async () => {
    try {
      const premiumData = {
        page: 1,
        size: 6,
        sort: "studentCount",
        orderBy: "DESC",
        activation: "Active",
        isFree: "Inactive",
      };
      const premiumResponse = (await LectureApi.getList(premiumData)).data.data
        .content;
      setMostPremiumList(premiumResponse);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getMyMembershipInfo = async () => {
    try {
      const member = (await MemberApi.getMyInfo()).data.data.content;
      const subscribed = Boolean(member?.membership);
      setIsSubscribed(subscribed);
      sessionStorage.setItem("membership", String(subscribed));

      const response = (await PaymentApi.getMyMemebership()).data.data.content;

      setMembershipInfo(response);
    } catch (error) {
      // errorHandler(error);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") return;
    dataListFunc();
  }, [location, selectedType]); // eslint-disable-line react-hooks/exhaustive-deps

  const dataListFunc = async () => {
    try {
      const data = {
        page: page,
        size: pagination.size,
        ...(selectedType === typeList[1] && { isCancel: "Inactive" }),
        ...(selectedType === typeList[2] && { isCancel: "Active" }),
      };

      const response = (await PaymentApi.membershipGetList(data)).data.data;

      setDataList(response.content ?? []);
      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      }));
    } catch (error) {
      errorHandler(error);
    }
  };

  const membershipCancelFunc = async () => {
    if (isCanceling) return;
    if (membershipInfo.membershipStatus === "CANCEL") {
      toast("이미 구독 해지를 신청했습니다.");
      setIsModalOpen(false);
      return;
    }

    try {
      setIsCanceling(true);
      await PaymentApi.membershipCancel();

      const myInfoRP = (await MemberApi.getMyInfo()).data.data.content;
      sessionStorage.setItem("membership", myInfoRP.membership);
      setMembershipInfo((prev) => ({
        ...prev,
        membershipStatus: "CANCEL",
      }));
      await dataListFunc();
      toast("구독 해지되었습니다.");
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsCanceling(false);
      setIsModalOpen(false);
    }
  };

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              color: "#000",
              marginBottom: 32,
            }}
          >
            👨‍💻 마이페이지
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {tabList.map((tab, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  <StyledCategoryItem
                    onClick={() => navigate(tab.path)}
                    isActive={index === 4 ? true : false}
                    title={tab.title}
                  />

                  {index === 4 && (
                    <SubTabWrapper>
                      {paymentSubTabList.map((subTab, index) => (
                        <StyledSubCategoryItem
                          key={index}
                          onClick={() => {
                            navigate(subTab.path);
                          }}
                          title={subTab.title}
                          isActive={index === 0 ? true : false}
                        />
                      ))}
                    </SubTabWrapper>
                  )}
                </div>
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 30,
              }}
            >
              <ContentContainer>
                <ContentHeaderWrapper>
                  <LSRgDisplay02 style={{ color: "#000" }}>
                    구독 관리
                  </LSRgDisplay02>
                </ContentHeaderWrapper>

                <TypeWrapper>
                  <Type
                    isActive={selectedType === typeList[0]}
                    onClick={() => {
                      setSelectedType(typeList[0]);
                      setSearchParams({});
                    }}
                  >
                    <LSRgH2HeadLine
                      style={{
                        color:
                          selectedType === typeList[0] ? "#000" : "#898E99",
                      }}
                    >
                      {typeList[0]}
                    </LSRgH2HeadLine>
                  </Type>
                  <Type
                    isActive={
                      selectedType === typeList[1] ||
                      selectedType === typeList[2]
                    }
                    onClick={() => {
                      setSelectedType(isSubscribed ? typeList[1] : typeList[2]);
                      setSearchParams({});
                    }}
                  >
                    <LSRgH2HeadLine
                      style={{
                        color:
                          selectedType === typeList[1] ||
                          selectedType === typeList[2]
                            ? "#000"
                            : "#898E99",
                      }}
                    >
                      {isSubscribed ? typeList[1] : typeList[2]}
                    </LSRgH2HeadLine>
                  </Type>
                </TypeWrapper>
                {selectedType === typeList[0] && (
                  <>
                    <ContentBodyWrapper>
                      <MainImg
                        src={
                          isSubscribed
                            ? "/assets/images/lovely_face.png"
                            : "/assets/images/subscribe_box.png"
                        }
                        alt="구독 이미지"
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          alignSelf: "center",
                          gap: 8,
                        }}
                      >
                        <LSBdDisplay02>
                          {isSubscribed
                            ? "핀라이브를 구독하고 계시네요!"
                            : "핀라이브 구독하고 혜택 받아보세요!"}
                        </LSBdDisplay02>
                        <LSRgH2HeadLine
                          style={{
                            textAlign: "center",
                          }}
                        >
                          {isSubscribed
                            ? membershipInfo?.membershipStatus === "CANCEL"
                              ? "현재 구독 해지 신청되었습니다.\n다음 결제일 전까지 이용할 수 있습니다."
                              : `다음 결제 예정일은 ${moment(
                                  membershipInfo?.startDate,
                                )
                                  .add(1, "months")
                                  .format("YYYY년 MM월 DD일")}입니다.`
                            : "모든 유료 강의를 무료로 수강할 수 있어요."}
                        </LSRgH2HeadLine>
                      </div>
                      {!isSubscribed && (
                        <PrimaryBtn
                          style={{
                            marginTop: 50,
                            alignSelf: "center",
                          }}
                          btnText="구독하기"
                          onClick={() => {
                            navigate(route.my_page_payment_subscribe);
                          }}
                        />
                      )}
                    </ContentBodyWrapper>
                    <ContentBottomContainer>
                      <ContentBottomTextWrapper>
                        <LSRgDisplay02>유료 강의를 모두 0원으로!</LSRgDisplay02>
                        <LSRgH2HeadLine>
                          모든 유료 강의를 구독 기간동안 0원으로 수강하실 수
                          있어요.
                        </LSRgH2HeadLine>
                      </ContentBottomTextWrapper>
                      {mostPremiumList.length > 0 ? (
                        <LectureSwiper
                          dataList={mostPremiumList}
                          isMiddle={true}
                        />
                      ) : (
                        <Empty title={"등록된 강의가 없습니다."} />
                      )}

                      <MainBorderBtn
                        onClick={() => {
                          navigate(route.lecture_list);
                        }}
                        style={{
                          width: 380,
                          alignSelf: "center",
                          marginTop: 61,
                        }}
                      >
                        구독 혜택 강의 더보기
                      </MainBorderBtn>
                    </ContentBottomContainer>
                    {isSubscribed &&
                      membershipInfo?.membershipStatus !== "CANCEL" && (
                        <TerminationContainer>
                          <ContentBottomTextWrapper>
                            <LSRgDisplay02>
                              구독을 해지하실 건가요?
                            </LSRgDisplay02>
                            <LSRgH2HeadLine>
                              구독을 해지할 경우 다음 결제일 전까지 이용할 수
                              있습니다.
                            </LSRgH2HeadLine>
                          </ContentBottomTextWrapper>
                          <TerminationBtn
                            onClick={() => {
                              setIsModalOpen(true);
                            }}
                          >
                            <LSRgH1HeadLine style={{ color: "#898E99" }}>
                              구독 해지하기
                            </LSRgH1HeadLine>
                          </TerminationBtn>
                        </TerminationContainer>
                      )}
                  </>
                )}

                {(selectedType === typeList[1] ||
                  selectedType === typeList[2]) && (
                  <>
                    <Table>
                      <thead>
                        <Tr
                          style={{
                            height: 41,
                            backgroundColor: "#EDEDFF",
                          }}
                        >
                          <th
                            style={{
                              width: 146,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <LSRgBody02 style={{ color: "#101113" }}>
                              구독일자
                            </LSRgBody02>
                          </th>
                          <th
                            style={{
                              width: 557,
                              display: "flex",
                              alignItems: "center",
                              paddingLeft: 10,
                            }}
                          >
                            <LSRgBody02 style={{ color: "#101113" }}>
                              내용
                            </LSRgBody02>
                          </th>
                          <th
                            style={{
                              width: 146,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <LSRgBody02 style={{ color: "#101113" }}>
                              결제금액
                            </LSRgBody02>
                          </th>
                          <th
                            style={{
                              width: 146,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <LSRgBody02 style={{ color: "#101113" }}>
                              결제상태
                            </LSRgBody02>
                          </th>
                        </Tr>
                      </thead>
                      <tbody>
                        {dataList.length > 0 ? (
                          dataList.map((item) => (
                            <Tr key={item.id}>
                              <td
                                style={{
                                  width: 146,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <LSRgBody02 style={{ color: "#101113" }}>
                                  {moment(item.createdAt).format("YYYY.MM.DD")}
                                </LSRgBody02>
                              </td>
                              <td
                                style={{
                                  width: 557,
                                  display: "flex",
                                  alignItems: "center",
                                  paddingLeft: 10,
                                }}
                              >
                                <LSRgBody02 style={{ color: "#101113" }}>
                                  {item.isCancel ? "구독 해지" : "구독 결제"}
                                </LSRgBody02>
                              </td>
                              <td
                                style={{
                                  width: 146,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <LSRgBody02 style={{ color: "#101113" }}>
                                  {item.isCancel
                                    ? 0
                                    : formatNumberWithCommas(item.price)}
                                  원
                                </LSRgBody02>
                              </td>
                              <td
                                style={{
                                  width: 146,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <LSRgBody02 style={{ color: "#101113" }}>
                                  {item.isCancel ? "구독해지" : "결제완료"}
                                </LSRgBody02>
                              </td>
                            </Tr>
                          ))
                        ) : (
                          <Empty title={"구독 내역이 없습니다."} />
                        )}
                      </tbody>
                    </Table>

                    {dataList.length > 0 && (
                      <Pagination
                        route={route.my_page_payment}
                        queryString={``}
                        currentPage={Number(page) || 1}
                        totalPages={pagination.totalPages}
                        rangeSize={pagination.rangeSize}
                      />
                    )}
                  </>
                )}
              </ContentContainer>
            </div>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>👨‍💻 마이페이지</LSRgH1HeadLine>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={subMenuBoxOpen}
                  isLink={true}
                  selectedValue={selectedSubMenu}
                  wrapperHandler={() => {
                    setSubMenuBoxOpen(!subMenuBoxOpen);
                  }}
                  itemList={tabList}
                  selectedValueSetterFunc={setSelectedSubMenu}
                />

                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={selectedSubMenuTabOpen}
                  isLink={true}
                  selectedValue={selectedSubMenuTab}
                  wrapperHandler={() => {
                    setSelectedSubMenuTabOpen(!selectedSubMenuTabOpen);
                  }}
                  itemList={paymentSubTabList}
                  selectedValueSetterFunc={setSelectedSubMenuTab}
                />
              </div>
            </ContentHeaderWrapper>

            <LSRgH1HeadLine style={{ marginBottom: 20 }}>
              구독 관리
            </LSRgH1HeadLine>

            {/* 본문 영역 */}
            <TypeWrapper $isSmall={isSmall}>
              <Type
                $isSmall={isSmall}
                isActive={selectedType === typeList[0]}
                onClick={() => {
                  setSelectedType(typeList[0]);
                  setSearchParams({});
                }}
              >
                <LSRgH2HeadLine
                  style={{
                    color: selectedType === typeList[0] ? "#000" : "#898E99",
                  }}
                >
                  {typeList[0]}
                </LSRgH2HeadLine>
              </Type>
              <Type
                $isSmall={isSmall}
                isActive={
                  selectedType === typeList[1] || selectedType === typeList[2]
                }
                onClick={() => {
                  setSelectedType(isSubscribed ? typeList[1] : typeList[2]);
                  setSearchParams({});
                }}
              >
                <LSRgH2HeadLine
                  style={{
                    color:
                      selectedType === typeList[1] ||
                      selectedType === typeList[2]
                        ? "#000"
                        : "#898E99",
                  }}
                >
                  {isSubscribed ? typeList[1] : typeList[2]}
                </LSRgH2HeadLine>
              </Type>
            </TypeWrapper>

            {selectedType === typeList[0] && (
              <>
                <ContentBodyWrapper $isSmall={isSmall}>
                  <MainImg
                    $isSmall={isSmall}
                    src={
                      isSubscribed
                        ? "/assets/images/lovely_face_m.png"
                        : "/assets/images/subscribe_box_m.png"
                    }
                    alt="구독 이미지"
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      alignSelf: "center",
                      gap: 4,
                    }}
                  >
                    <LSBdH2HeadLine>
                      {isSubscribed
                        ? "핀라이브를 구독하고 계시네요!"
                        : "핀라이브 구독하고 혜택 받아보세요!"}
                    </LSBdH2HeadLine>
                    <LSRgCaption02
                      style={{
                        textAlign: "center",
                      }}
                    >
                      {isSubscribed
                        ? membershipInfo?.membershipStatus === "CANCEL"
                          ? "현재 구독 해지 신청되었습니다.\n다음 결제일 전까지 이용할 수 있습니다."
                          : `다음 결제 예정일은 ${moment(
                              membershipInfo?.startDate,
                            )
                              .add(1, "months")
                              .format("YYYY년 MM월 DD일")}입니다.`
                        : "모든 유료 강의를 무료로 수강할 수 있어요."}
                    </LSRgCaption02>
                  </div>
                  {!isSubscribed && (
                    <PrimaryBtn
                      style={{
                        width: 335,
                        marginTop: 60,
                        alignSelf: "center",
                      }}
                      btnText="구독하기"
                      onClick={() => {
                        navigate(route.my_page_payment_subscribe);
                      }}
                    />
                  )}
                </ContentBodyWrapper>

                <ContentBottomContainer $isSmall={isSmall}>
                  <ContentBottomTextWrapper $isSmall={isSmall}>
                    <LSRgH1HeadLine>유료 강의를 모두 0원으로!</LSRgH1HeadLine>
                    <LSRgCaption02 style={{ color: "#898e99" }}>
                      모든 유료 강의를 구독 기간동안 0원으로 수강하실 수 있어요.
                    </LSRgCaption02>
                  </ContentBottomTextWrapper>
                  <OverflowXHidden>
                    {mostPremiumList.length > 0 ? (
                      mostPremiumList.map((item, index) => {
                        return <LectureItem data={item} key={index} />;
                      })
                    ) : (
                      <Empty title={"등록된 강의가 없습니다."} />
                    )}
                  </OverflowXHidden>
                  <MainBorderBtn
                    onClick={() => {
                      navigate(route.lecture_list);
                    }}
                    style={{
                      width: 335,
                      alignSelf: "center",
                      marginTop: 40,
                    }}
                  >
                    구독 혜택 강의 더보기
                  </MainBorderBtn>
                </ContentBottomContainer>

                {isSubscribed &&
                  membershipInfo?.membershipStatus !== "CANCEL" && (
                    <TerminationContainer $isSmall={isSmall}>
                      <ContentBottomTextWrapper $isSmall={isSmall}>
                        <LSRgH1HeadLine>구독을 해지하실 건가요?</LSRgH1HeadLine>
                        <LSRgCaption02 style={{ color: "#898e99" }}>
                          구독을 해지할 경우 다음 결제일 전까지 이용할 수
                          있습니다.
                        </LSRgCaption02>
                      </ContentBottomTextWrapper>
                      <TerminationBtn
                        onClick={() => {
                          setIsModalOpen(true);
                        }}
                      >
                        <LSRgH1HeadLine style={{ color: "#898E99" }}>
                          구독 해지하기
                        </LSRgH1HeadLine>
                      </TerminationBtn>
                    </TerminationContainer>
                  )}
              </>
            )}

            {(selectedType === typeList[1] || selectedType === typeList[2]) && (
              <>
                <Table $isSmall={isSmall} style={{ marginTop: 20 }}>
                  <thead>
                    <Tr
                      $isSmall={isSmall}
                      style={{
                        height: 32,
                        backgroundColor: "#EDEDFF",
                      }}
                    >
                      <th
                        style={{
                          width: 84,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LSRgCaption01 style={{ color: "#101113" }}>
                          구독일자
                        </LSRgCaption01>
                      </th>
                      <th
                        style={{
                          width: 117,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <LSRgCaption01 style={{ color: "#101113" }}>
                          내용
                        </LSRgCaption01>
                      </th>
                      <th
                        style={{
                          width: 70,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LSRgCaption01 style={{ color: "#101113" }}>
                          결제금액
                        </LSRgCaption01>
                      </th>
                      <th
                        style={{
                          width: 70,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LSRgCaption01 style={{ color: "#101113" }}>
                          결제상태
                        </LSRgCaption01>
                      </th>
                    </Tr>
                  </thead>
                  <tbody>
                    {dataList.length > 0 ? (
                      dataList.map((item) => (
                        <Tr $isSmall={isSmall} key={item.id}>
                          <td
                            style={{
                              width: 84,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <LSRgCaption01 style={{ color: "#101113" }}>
                              {moment(item.createdAt).format("YYYY.MM.DD")}
                            </LSRgCaption01>
                          </td>
                          <td
                            style={{
                              width: 117,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <LSRgCaption01 style={{ color: "#101113" }}>
                              {item.isCancel ? "구독 해지" : "구독 결제"}
                            </LSRgCaption01>
                          </td>
                          <td
                            style={{
                              width: 70,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <LSRgCaption01 style={{ color: "#101113" }}>
                              {item.isCancel
                                ? 0
                                : formatNumberWithCommas(item.price)}
                              원
                            </LSRgCaption01>
                          </td>
                          <td
                            style={{
                              width: 70,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <LSRgCaption01 style={{ color: "#101113" }}>
                              {item.isCancel ? "구독해지" : "결제완료"}
                            </LSRgCaption01>
                          </td>
                        </Tr>
                      ))
                    ) : (
                      <Empty title={"구독 내역이 없습니다."} />
                    )}
                  </tbody>
                </Table>

                {dataList.length > 0 && (
                  <Pagination
                    route={route.my_page_payment}
                    queryString={``}
                    currentPage={Number(page) || 1}
                    totalPages={pagination.totalPages}
                    rangeSize={pagination.rangeSize}
                  />
                )}
              </>
            )}
          </ContentContainer>
        </MOContainer>
      )}

      {/* 모달 */}
      {isModalOpen && (
        <ConfirmModal
          isScroll={false}
          title={"구독 해지"}
          content={
            <>
              구독을 해지할 경우 다음 결제일 전까지 이용할 수 있습니다.
              <br />
              구독을 해지하실 건가요?
            </>
          }
          isNegative={true}
          yText={"해지하기"}
          onClick={() => {
            setIsModalOpen(false);
          }}
          onYClick={() => {
            setIsModalOpen(false);

            membershipCancelFunc();
          }}
        />
      )}
    </HomeSection>
  );
};

export default MyPagePayment;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SubTabWrapper = styled.div.attrs((props) => {})`
  width: 175px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -6px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: ${(props) => (props.$isSmall ? "stretch" : "center")};
  justify-content: space-between;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  gap: ${(props) => (props.$isSmall ? "16px" : "0px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const ContentBodyWrapper = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  display: flex;
  flex-direction: column;
`;

const TypeWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: ${(props) => (props.$isSmall ? "40px" : "60px")};
  margin-bottom: ${(props) => (props.$isSmall ? "0px" : "50px")};
`;

const Type = styled.button.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "153px" : "483px")};
  height: ${(props) => (props.$isSmall ? "40px" : "60px")};
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: ${(props) => (props.isActive ? "2px solid #5050FF" : "none")};
`;

const MainImg = styled.img.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "380px")};
  height: ${(props) => (props.$isSmall ? "190px" : "240px")};
  object-fit: cover;
  align-self: center;
`;

const ContentBottomContainer = styled.div.attrs((props) => {})`
  margin-top: ${(props) => (props.$isSmall ? "60px" : "100px")};
  display: flex;
  flex-direction: column;
  border-top: 1px solid #dbdde0;
`;

const ContentBottomTextWrapper = styled.div.attrs((props) => {})`
  margin-top: ${(props) => (props.$isSmall ? "60px" : "50px")};
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: ${(props) => (props.$isSmall ? "20px" : "30px")};
`;

const TerminationContainer = styled.div.attrs((props) => {})`
  margin-top: ${(props) => (props.$isSmall ? "60px" : "50px")};
  display: flex;
  flex-direction: column;
  border-top: 1px solid #dbdde0;
`;

const TerminationBtn = styled.button.attrs((props) => {})`
  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;
  width: fit-content;
  padding: 10px;
  border-bottom: 1px solid #898e99;
  cursor: pointer;
`;

const Table = styled.table.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  border-spacing: 0px;
  border-collapse: collapse;
`;

const Tr = styled.tr.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: ${(props) => (props.$isSmall ? "44px" : "52px")};
  border-bottom: 1px solid #dbdde0;
  padding: 16px 0px;
  display: flex;
  align-items: center;
`;

const OverflowXHidden = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  overflow-x: auto;
  width: 100%;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* 인터넷 익스플로러 */
  scrollbar-width: none; /* 파이어폭스 */
`;
